// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__fpGbd","shimmer":"styles_shimmer__jGTOJ","relative-scrollbar":"styles_relative-scrollbar__U+g+g"};